import React, { useState } from 'react';
import { 
  FileDown, 
  ShieldCheck, 
  Download, 
  Printer, 
  CheckCircle2,
  Info
} from 'lucide-react';
import { useStore } from '../../store/useStore';

export const IncidentExporterPage: React.FC = () => {
  const { user, recoveryCase } = useStore();

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 text-emerald-300 text-xs font-bold border border-emerald-800">
          <FileDown className="w-3.5 h-3.5" />
          <span>POLICE & REPORTCYBER EVIDENCE PACKAGER</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Incident Evidence Dossier Exporter</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Generate an official, formatted incident dossier with chronological timelines, breach records, and action logs for state police and banks.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        <div className="flex items-center justify-between border-b border-slate-800 pb-4">
          <div>
            <h3 className="text-base font-bold text-white">Australian Identity Incident Dossier</h3>
            <p className="text-slate-400">Victim: {user?.firstName} {user?.lastName} ({user?.email})</p>
          </div>
          <button
            onClick={handlePrint}
            className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl font-bold flex items-center gap-1.5 shadow-lg"
          >
            <Printer className="w-4 h-4" />
            <span>Print Evidence Package</span>
          </button>
        </div>

        <div className="space-y-4 font-mono text-[11px] bg-slate-950 p-6 rounded-2xl border border-slate-800">
          <div>INCIDENT TITLE: {recoveryCase.incidentTitle}</div>
          <div>CASE STATUS: {recoveryCase.status.toUpperCase()} ({recoveryCase.completedStepsCount} of {recoveryCase.totalStepsCount} Steps Resolved)</div>
          <div>GENERATED: {new Date().toLocaleString('en-AU')}</div>
          <hr className="border-slate-800 my-3" />
          <div className="space-y-1">
            <div className="font-bold text-white font-sans text-xs">RECOVERY AUDIT TRAIL:</div>
            {recoveryCase.steps.map(s => (
              <div key={s.id} className="text-slate-300">
                [{s.isCompleted ? 'RESOLVED' : 'PENDING'}] Step {s.stepNumber}: {s.title}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
